import React from "react";

export default function Script() {
  return (
    <>
      <script
        type="text/javascript"
        src="../../assets/js/jquery-3.5.1.min.js"
      ></script>
      <script
        type="text/javascript"
        src="../../assets/js/jquery.inputmask.bundle.js"
      ></script>
      <script
        type="text/javascript"
        src="../../assets/js/jquery.validate.min.js"
      ></script>
      <script
        type="text/javascript"
        src="../../assets/js/localization/messages_tr.min.js"
      ></script>
      <script
        type="text/javascript"
        src="../../assets/js/jquery.fancybox.min.js"
      ></script>
      <script
        type="text/javascript"
        src="../../assets/js/slick.min.js"
      ></script>
      <script
        type="text/javascript"
        src="../../assets/js/jquery.nice-select.min.js"
      ></script>
      <script type="text/javascript" src="../../assets/js/main.js"></script>
      <script type="text/javascript" src="../../assets/js/home.js"></script>
      <script type="text/javascript" src="../../assets/js/Forms.js"></script>
      <script type="text/javascript" src="../../assets/js/form.js"></script>
      <script type="text/javascript" src="../../assets/js/cookie.js"></script>
    </>
  );
}
